export enum EnumUserType{
    Anonymous = -1,
    WholesaleUser = 1,
    Administrator = 2,
    RetailUser = 3,
    SP = 4,
    SMM = 5

}
